import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  httpHeaderOptions: any;
  constructor(public http: HttpClient) {
    this.httpHeaderOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
    // this.tokens =null
  }

  login(data: any) {
    return this.http.post(environment.apiEndpoint + 'login/', data,this.httpHeaderOptions);
  }

  signin(data: any) {
    return this.http.post(environment.apiEndpoint + 'login_new/', data,this.httpHeaderOptions);
  }

  forgotpassword(data: any) {
    return this.http.post(environment.apiEndpoint + 'forgot_password/', data,this.httpHeaderOptions);
  }

  // singlesing(){
  //   return this.http.post(environment.apiEndpoint + 'single_sign_on/',null,this.httpHeaderOptions)
  // }

  // tourandtravelSingON(){
  //   return this.http.post(environment.apiEndpoint + 'single_sign_on_tour_and_travels/',null,this.httpHeaderOptions)
  // }

  fetchFields(){
    return this.http.get(environment.apiEndpoint + 'hrms/core_user_data_update/',this.httpHeaderOptions)
  } 

  updateFetchFields(data:any){
    return this.http.put(environment.apiEndpoint + 'hrms/core_user_data_update/',data,this.httpHeaderOptions)
  }
}
